import React from 'react'
import { Image, StyleSheet, TouchableOpacity } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { defaultImage } from '@assets'
import { Icon, Text } from '../atoms'

interface NotePersonLineProps {
  name: string
  avatarUrl?: string | null
  // « il y a 6 jours », or null when nothing was exchanged yet.
  lastExchange: string | null
  onPress: () => void
}

// On the phone the person of a note takes a single line, so that a long note
// keeps the screen: « Chloe Bernard · il y a 6 jours › ». A tap opens the
// details.
export const NotePersonLine = ({ name, avatarUrl, lastExchange, onPress }: NotePersonLineProps) => {
  const theme = useTheme()
  // « · il y a 6 jours », after the name.
  const lastExchangeLabel = lastExchange ? `· ${lastExchange}` : null

  return (
    <TouchableOpacity testID="note-person-line" style={styles.line} onPress={onPress}>
      <Image source={avatarUrl ? { uri: avatarUrl } : defaultImage} style={styles.avatar} />
      <Text type="bodyBold" numberOfLines={1} style={styles.name}>
        {name}
      </Text>
      {!!lastExchangeLabel && (
        <Text
          type="bodySmall"
          color={theme.colors.greyBlue}
          numberOfLines={1}
          style={styles.lastExchange}
        >
          {lastExchangeLabel}
        </Text>
      )}
      <Icon name="arrow" size={20} color={theme.colors.primary} containerStyle={styles.chevron} />
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  line: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  avatar: {
    width: 30,
    height: 30,
    borderRadius: 15,
  },
  name: {
    flexShrink: 1,
  },
  lastExchange: {
    flexShrink: 1,
  },
  chevron: {
    marginLeft: 'auto',
  },
})
